import {
  queryOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { client } from "$api/client";

export const queryKeys = {
  attributes: ["attributes"],
  numAttributes: () => [...queryKeys.attributes, "numberOfAttributes"],
};

export const attributeDataOption = queryOptions({
  queryKey: queryKeys.attributes,
  queryFn: async () => {
    const response = await client.get("/attribute/");
    return response?.data;
  },
});
export const getNumberOfAttributes = (municipalUtilityId) =>
  queryOptions({
    queryKey: queryKeys.numAttributes(),
    queryFn: async () => {
      const { data } = await client.get(
        `/municipal_utility/${municipalUtilityId}/num_attributes`
      );

      return data;
    },
  });

export const usePostCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (parameters) => {
      const { data } = await client.post(
        "/attribute/",
        { ...parameters },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.attributes,
      });
    },
  });
};

export const usePutAttribute = (queryKey) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (attributes) => {
      const url = process.env.REACT_APP_API_URL + `/attribute/`;
      const { data } = await client.put(url, attributes);

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: (error) => {
      const { status } = error;
      if (status && 400 <= status && status < 500) {
        // assume user error so do nothing
        console.error(error);
      } else {
        // invalidate to remove unsaved user templates
        queryClient.invalidateQueries({ queryKey: queryKeys.attributes });
      }
    },
  });
};
